import React, { useEffect } from 'react'

import './auth.css'
import { Logo } from 'assets'
import { Button } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'
import { atenyaUser, UrlRegex, userType } from 'constant/const'
import { useDispatch, useSelector } from 'react-redux'
import {
   addChannelAction,
   logoutAction,
   onLogoutAction,
   reset504Status,
   setUserDataLocal
} from 'store/action/AuthRedux'
import { convertObjectToFormData } from 'utils/convertFormData'
import { Loader } from 'components'
import axiosInstance from 'utils/axiosConfig'

function AddChannel() {
   const authData = useSelector((state) => state.user)
   const { userData, loading, addChannel, addChannel504StatusError } = authData
   const navigate = useNavigate()
   const method = useForm()
   const {
      register,
      formState: { errors },
      handleSubmit,
      setValue
   } = method
   const dispatch = useDispatch()

   useEffect(() => {
      setValue('user_type', userType.OWNER)
      return () => {}
   }, [])

   useEffect(() => {
      if (!userData && !userData?.access) {
         navigate('/auth/login')
      }
      return () => {}
   }, [userData])

   useEffect(() => {
      if (addChannel) {
         dispatch(setUserDataLocal({ ...userData, is_channel_exists: true }))
         addChannel504StatusError && dispatch(reset504Status())
         navigate('/auth/welcome')
      }
      return () => {}
   }, [addChannel])

   const onSubmit = (data) => {
      onClickReadPrivacyPolicy()
      const dd = convertObjectToFormData(data)
      dispatch(addChannelAction(dd))
   }

   const onClickReadPrivacyPolicy = async () => {
      try {
         let formData = convertObjectToFormData({
            is_privacy_checked: true
         })
         let res = await axiosInstance.post('/user/user-update/', formData, {
            headers: {
               Authorization: `Bearer ${userData?.access}`
            }
         })
         console.log('res.data', res.data)
         if (res.data?.data) {
            let data = { ...userData, is_privacy_checked: true }
            dispatch(setUserDataLocal(data))
         }
      } catch (err) {
         console.log(err)
      }
   }

   return (
      <div className="auth-section p-3 position-relative min-vh-100">
         {loading && <Loader message={'Please wait while we set up your account...'} />}
         <div className="auth-wrap">
            <div className="form-section-wrap">
               <div className="logo-section">
                  <img src={Logo} alt="logo" />
               </div>
               <form>
                  <div className="form-section ">
                     <h1 className="at-text-dark add-channel">Add Your Channel</h1>
                     <div className="at-form">
                        <div className="mb-2">
                           <label className="at-text-dark">YouTube URL</label>
                           <input
                              type="url"
                              className={`at-input form-control ${
                                 errors?.channel_url ? 'error' : ''
                              }`}
                              placeholder="https://youtube.com/@channelname"
                              {...register('channel_url', {
                                 required: {
                                    value: true,
                                    message: 'Please enter the channel link'
                                 },
                                 pattern: {
                                    value: UrlRegex,
                                    message: 'Please enter valid url'
                                 }
                              })}
                           />
                           <span className="error-text">
                              <ErrorMessage
                                 errors={errors}
                                 name="channel_url"
                                 message={errors?.channel_url?.message}
                              />
                           </span>
                        </div>
                        <div className="form-check">
                           <input
                              className="form-check-input"
                              type="checkbox"
                              id="flexCheckDefault"
                              {...register('is_privacy_checked', {
                                 required: {
                                    value: true,
                                    message: 'Please check privacy policy.'
                                 }
                              })}
                           />
                           <label className="form-check-label m-0">
                              <label htmlFor="flexCheckDefault" className="m-0">
                                 By signing up you agree to our{' '}
                              </label>
                              <Link
                                 to={'/terms-condition'}
                                 target="_blank"
                                 className="text-primary text-decoration-underline">
                                 Terms and conditions
                              </Link>{' '}
                              and{' '}
                              <Link
                                 to={'/privacy-policy'}
                                 target="_blank"
                                 className="text-primary text-decoration-underline">
                                 Privacy policy.
                              </Link>
                           </label>
                        </div>
                        <span className="error-text">
                           <ErrorMessage
                              errors={errors}
                              name="is_privacy_checked"
                              message={errors?.is_privacy_checked?.message}
                           />
                        </span>
                     </div>

                     <div className="mt-3 w-100">
                        <Button className="at-auth-btn w-100" onClick={handleSubmit(onSubmit)}>
                           Next
                        </Button>
                     </div>
                     <p className="mt-2 at-text-light">
                        Have an account?{' '}
                        <Link
                           to={'/auth/login'}
                           onClick={() => {
                              let formData = convertObjectToFormData({
                                 refresh: userData?.refresh,
                                 access: userData?.access,
                                 user_history_id: userData?.user_history_id
                              })
                              dispatch(onLogoutAction(formData))
                           }}
                           style={{ color: '#286BFF', textDecoration: 'underline' }}>
                           Log In
                        </Link>
                     </p>
                  </div>
               </form>
            </div>
            <div className="d-none d-lg-block right-side-section  ">
               <div className="auth-bg-image"></div>
            </div>
         </div>
      </div>
   )
}

export default AddChannel
